import home from "assets/img-login-admin.jpg";
import { Grid } from "@mui/material";

export const PublicLayout = ({ children }: { children: React.ReactNode }) => {
    return (
      <Grid
          container
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            minHeight: "100%",
          }}
        >
          <Grid
            sx={{
              width: "60%",
              height: "100vh",
              minHeight: "100%",
              display: "flex",
              alignItems: "flex-end",
              backgroundImage: `url(${home})`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              backgroundSize: "cover",
            }}
          ></Grid>
           <Grid
          sx={{
            width: "40%",
            padding: "0 1rem 0 1rem",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          {children}
        </Grid>
      </Grid>
    )
  } 